export default __webpack_public_path__ + "static/media/close.10fa8da4.svg";